class Trustpilot extends HTMLElement {

    constructor(){
        super();
        if(document.querySelectorAll('.custom-payment-options trustpilot-summary').length < 1){
            this.isMobile = window.innerWidth < 768 ? true : false;
            this.definePlacement();
            this.buildSelecotrs();
            this.fetchData();         
        }
    }

    static getElementName(){
        return 'trustpilot-summary'
    }

    get companyName(){
        return "www.fragranceoutlet.com"
    }

    definePlacement(){
        const desktopTpWrapper = document.querySelector('footer.footer-wrapper .footer-bottom-pane-wrap div');
        if(this.isMobile || !desktopTpWrapper) return;

        desktopTpWrapper.prepend(this);
    }

    buildSelecotrs(){
        this.tpScore = document.querySelectorAll('[data-tp-score]');
        this.tpReview = document.querySelectorAll('[data-tp-reviews]');
        // this.srOnly = this.querySelector('.visually-hidden');
        this.globalTpSrOnly = document.querySelectorAll('[data-tp-sr-only]');
        this.tpStar = document.querySelectorAll('[data-tp-star]');
    }
    repaintContent(){
        this.buildSelecotrs();
        this.render();
        this.updateGlobalSrOnlyText();
    }

    async fetchData(){
        try {
            const resp = await fetch(
                `https://api.trustpilot.com/v1/business-units/find?name=${this.companyName}`, 
                {
                    headers: { 'apikey': 'zNlIcAz5B0lOjhvtxwIdeGYeFRh7XFMA', 'Content-Type': 'application/json' }
                }
            );

            const data = await resp.json();
            this.data = data;
            this.render();
            this.updateGlobalSrOnlyText();
        } catch(err){
            console.log(err);
        }
    }

    updateGlobalSrOnlyText(){
        if(!this.data) return;
        const reviewText = 'TrustScore ' + this.data.score.trustScore + ' stars out of 5 stars rating on Trustpilot. Based on ' + this.data.numberOfReviews.total + ' reviews';
        const srText = `TrustScore ${this.data.score.trustScore} ${this.data.numberOfReviews.total} reviews`;
        this.globalTpSrOnly = document.querySelectorAll('[data-tp-sr-only]');
        this.globalTpSrOnly.forEach(elem => {
            elem.textContent = reviewText;
            const parentLink = elem.closest('a');
            if(parentLink) {
                parentLink.setAttribute('aria-label', srText);
                parentLink.setAttribute('aria-description', reviewText);
            }
        });
    }

    render(){
        if(!this.data) return;
        if(!this.data.status || this.data.status !== 'active') return;
        this.tpScore.forEach(item => {
            item.innerHTML = 'TrustScore <strong>'+ this.data.score.trustScore +'</strong>';
        })
        this.tpReview.forEach(item => {
            item.innerHTML = '<strong>'+ this.data.numberOfReviews.total +'</strong> reviews';
        })
        this.tpStar.forEach(item => {
            item.innerHTML = this.data.score.trustScore;
        })
        // this.tpReview.innerHTML = '<strong>'+ this.data.numberOfReviews.total +'</strong> reviews';
        const reviewText = 'TrustScore ' + this.data.score.trustScore + ' stars out of 5 stars rating on Trustpilot. Based on ' + this.data.numberOfReviews.total + ' reviews';
        const link = this.querySelector('a');
        // link.setAttribute('aria-label', 'TrustScore ' + this.data.score.trustScore + ' ' + this.data.numberOfReviews.total + ' reviews');
        link.setAttribute('aria-description', reviewText);
        // this.srOnly.textContent = reviewText;
    }
}
if(!customElements.get(Trustpilot.getElementName()))
    customElements.define(Trustpilot.getElementName(), Trustpilot);